import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { cn } from "../../lib/utils";
import { 
  Clock, 
  CheckCircle2, 
  Crown,
  MessageCircle,
  Utensils,
  Dumbbell,
  ArrowRight
} from "lucide-react";

const PremiumPending = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen bg-[#0B0B0B] flex flex-col items-center justify-center px-6 py-12"
      data-testid="premium-pending"
    >
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-[#D4AF37]/5 rounded-full blur-[100px]" />
      </div>

      {/* Success Icon */}
      <div className="relative mb-8">
        <div className="w-20 h-20 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
          <CheckCircle2 className="w-10 h-10 text-[#D4AF37]" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-[#D4AF37] flex items-center justify-center">
          <Crown className="w-4 h-4 text-[#0B0B0B]" />
        </div>
      </div>

      {/* Title */}
      <h1 className="text-2xl font-heading font-black text-white text-center mb-2">
        ¡Perfil Completado!
      </h1>
      
      <p className="text-[#D4AF37] font-semibold text-center mb-6">
        PENDING GOAT REVIEW
      </p>

      {/* Message */}
      <Card className="bg-[#121212] border-[#2A2A2A] max-w-sm w-full mb-8">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
              <Clock className="w-5 h-5 text-[#D4AF37]" />
            </div>
            <div>
              <h3 className="text-white font-semibold mb-1">Tu coach está revisando tu perfil</h3>
              <p className="text-[#888] text-sm">
                En las próximas horas recibirás tu plan de entrenamiento y dieta personalizados.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* What's next */}
      <div className="max-w-sm w-full mb-8">
        <h3 className="text-[#888] text-xs uppercase tracking-wider mb-4 text-center">
          Qué viene ahora
        </h3>
        <div className="space-y-3">
          <div className="flex items-center gap-3 p-3 bg-[#1A1A1A] rounded-xl">
            <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center">
              <Utensils className="w-4 h-4 text-[#D4AF37]" />
            </div>
            <span className="text-white text-sm">Dieta personalizada según tu objetivo</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-[#1A1A1A] rounded-xl">
            <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center">
              <Dumbbell className="w-4 h-4 text-[#D4AF37]" />
            </div>
            <span className="text-white text-sm">Programa de entrenamiento adaptado</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-[#1A1A1A] rounded-xl">
            <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center">
              <MessageCircle className="w-4 h-4 text-[#D4AF37]" />
            </div>
            <span className="text-white text-sm">Seguimiento semanal con tu coach</span>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="max-w-sm w-full space-y-3">
        <Button
          onClick={() => navigate("/hoy")}
          className="w-full bg-[#D4AF37] hover:bg-[#E5C54D] text-[#0B0B0B] font-bold py-6"
          data-testid="go-to-app-btn"
        >
          Ir a la App
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
        
        <Button
          onClick={() => window.open("https://wa.me/34641099731?text=Hola!%20Acabo%20de%20completar%20mi%20perfil%20GOATGYM%20Premium", "_blank")}
          variant="outline"
          className="w-full border-green-500/30 text-green-400 hover:bg-green-500/10 py-6"
        >
          <MessageCircle className="w-5 h-5 mr-2" />
          Contactar por WhatsApp
        </Button>
      </div>

      {/* Footer */}
      <p className="text-[#444] text-xs text-center mt-8">
        Te notificaremos cuando tu plan esté listo
      </p>
    </div>
  );
};

export default PremiumPending;
